import { pageUrl } from '@/constants/url'
import { useScreenWidth } from '@/hooks/commons/useScreenWidth'
import { useAccess } from '@/hooks/commons/useAccess'
import {
  BellOutlined,
  CoffeeOutlined,
  PercentageOutlined,
  UnlockOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Menu, MenuProps } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation } from 'react-router-dom'
import classNames from 'classnames'

interface IGenerateLink {
  label: string
  url: string
}
const MenuLink = ({ label, url }: IGenerateLink) => {
  return <Link to={url}>{label}</Link>
}

export const LayoutAccount = () => {
  const location = useLocation()
  const { isDesktop } = useScreenWidth()

  const { t } = useTranslation()
  const { leaveEnabled } = useAccess()

  const items = useMemo(() => {
    const menuItems: MenuProps['items'] = [
      {
        label: (
          <MenuLink label={t('common.profile')} url={pageUrl.accountProfile} />
        ),
        key: pageUrl.accountProfile,
        icon: <UserOutlined />,
      },
      {
        label: (
          <MenuLink
            label={t('common.password.security')}
            url={pageUrl.accountPasswordSecurity}
          />
        ),
        key: pageUrl.accountPasswordSecurity,
        icon: <UnlockOutlined />,
      },
      {
        label: (
          <MenuLink
            label={t('common.push.notification')}
            url={pageUrl.pushNotification}
          />
        ),
        key: pageUrl.pushNotification,
        icon: <BellOutlined />,
      },
      {
        label: (
          <MenuLink
            label={t('common.my.commission')}
            url={pageUrl.myCommissions}
          />
        ),
        key: pageUrl.myCommissions,
        icon: <PercentageOutlined />,
      },
    ]
    if (leaveEnabled) {
      menuItems.push({
        label: (
          <MenuLink label={t('common.my.leave')} url={pageUrl.accountMyLeave} />
        ),
        key: pageUrl.accountMyLeave,
        icon: <CoffeeOutlined />,
      })
    }
    return menuItems
  }, [t, leaveEnabled])

  return (
    <div
      className={classNames('flex justify-center gap-4', {
        'flex-row': isDesktop,
        'flex-col': !isDesktop,
      })}
    >
      <div>
        <Menu
          className="rounded"
          items={items}
          selectedKeys={[location.pathname]}
          mode={isDesktop ? 'inline' : 'horizontal'}
        />
      </div>
      <div
        className={classNames('flex-1 ', {
          'max-w-[900px]': isDesktop,
        })}
      >
        <Outlet />
      </div>
    </div>
  )
}
